import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../../../@types/RootState';
import { ContextMenuItem } from '../../../../../../components';
import { AlertWithTimestamp } from '../../../../../../components/AlertWithTimestamp';
import { selectorContextMenuItemOffer } from '../../../../../../reducers/gerenciadorPrecos/contextMenu';
import { RuleCompositionOfferState, SET_DATA, SET_IS_OPEN } from '../../../../../../reducers/ipa/priceManager/modals/ruleCompositionOffer';
import { getRuleCompositionOfferData } from './service';

type RuleCompositionOfferContextMenuProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapToDispatch>;

const RuleCompositionOfferContextMenu = ({ offer, openModal, setData }: RuleCompositionOfferContextMenuProps) => {
  const handleOpen = useCallback(async () => {
    if (!offer) return;
    try {
      const response = await getRuleCompositionOfferData(offer);
      if (!response) throw new Error('Erro ao carregar composição de regra de preço 3 oferta');
      setData(response);
      openModal();
    } catch (err) {
      throw AlertWithTimestamp({ message: err.message });
    }
  }, [offer, setData, openModal]);

  if (!offer?.ruleId) return null;

  return <ContextMenuItem onClick={handleOpen}>Regra preço 3 Oferta</ContextMenuItem>;
};

const mapStateToProps = (state: RootState) => ({
  offer: selectorContextMenuItemOffer(state),
});

const mapToDispatch = (dispatch: Dispatch) => ({
  openModal: () => dispatch(SET_IS_OPEN(true)),
  setData: (payload: RuleCompositionOfferState['data']) => dispatch(SET_DATA(payload)),
});

export default connect(mapStateToProps, mapToDispatch)(RuleCompositionOfferContextMenu);
